module.exports = __webpack_public_path__ + "img/wx_follow_bg2.1eefd6a6.png";